import moment from 'moment';
import { getOnlyDigitsInput, isSlashPresent } from './stringHelper';
import { DATE_INPUT_CONSTANTS } from '../constants/dateInputConstants';
import { billPeriodFormat } from './billHelper';
type IDateValue = string | undefined | null | number | Date;
type IDate = string | Date;

type IEventType =
  | React.ChangeEvent<HTMLInputElement>
  | React.FocusEvent<HTMLInputElement>;

export const fullDateFormat = (event: IEventType): string => {
  const digits = getOnlyDigitsInput(event.target.value);
  if (digits) {
    event.target.value = '';
    const length = digits.length;
    const month = digits.slice(0, 2);
    const day = digits.slice(2, 4);
    const year = digits.slice(4);

    event.target.value = month;
    if (length > 2) {
      event.target.value += ' / ';
    }

    event.target.value += day;
    if (length > 4) {
      event.target.value += ' / ';
    }
    event.target.value += year;
  }
  return event.target.value;
};

export const dateFormater = (event: IEventType, fullDate?: boolean): string => {
  if (fullDate) {
    return fullDateFormat(event);
  }
  const isSlash =
    isSlashPresent(event.target.value) && event.target.value.length === 4;
  const numbers = getOnlyDigitsInput(event.target.value);
  event.target.value = '';
  return numbers.split('').map((number: string, i: number) => {
    return (event.target.value +=
      i === 1 ? (isSlash ? number : number + ' / ') : number);
  })[numbers.length - 1];
};

const checkMonthValid = (month: string): boolean => {
  if (month?.length === 2) {
    const monthNo = Number(month);
    return monthNo > 0 && monthNo <= 12;
  }
  return false;
};

const checkYearValid = (year: string, presentDate: string): boolean => {
  if (year?.length === 4) {
    const yearNo = Number(year);
    return yearNo >= 1000 && yearNo <= getCurrentYear(presentDate);
  }
  return false;
};

export const getCurrentYear = (presentDate: string): number => {
  return presentDate ? moment(presentDate).year() : moment().year();
};

const getCurrentMonth = (presentDate: string): number => {
  return presentDate ? moment(presentDate).month() + 1 : moment().month() + 1;
};

export const getMonthName = ({
  presentDate,
  monthSequence = 0,
}: {
  presentDate: string;
  monthSequence?: number;
}) => {
  let date = moment(presentDate, 'MM/DD/YYYY');

  if (monthSequence && monthSequence > 0) {
    date = moment(date).add(monthSequence, 'months');
  }
  return `${date.format('MMMM')}`;
};

const isYearCurrentYear = (year: string, presentDate: string): boolean => {
  return Number(year) === getCurrentYear(presentDate);
};

export const validateDOB = (
  dob: string,
  presentDate: string,
): { month: boolean; year: boolean } => {
  let isMonthValid = false;
  let isYearValid = false;
  if (dob !== undefined) {
    const [inputMonth, inputYear] = dob?.split(' / ');
    isMonthValid = checkMonthValid(inputMonth);
    isYearValid = checkYearValid(inputYear, presentDate);
    if (
      isMonthValid &&
      isYearValid &&
      isYearCurrentYear(inputYear, presentDate)
    ) {
      isMonthValid = Number(inputMonth) <= getCurrentMonth(presentDate);
    }
  }
  return {
    month: isMonthValid,
    year: isYearValid,
  };
};

export const validateFullDOBFormat = (
  dob: string,
  presentDate: string,
): boolean => {
  const { fieldLength } = DATE_INPUT_CONSTANTS;
  const [year] = dob?.split(' / ').reverse();
  const dobValidation = moment(dob, 'MM/DD/YYYY');
  if (
    dob.length === fieldLength.fulldateFormatLength &&
    dobValidation.isValid() &&
    dobValidation.isSameOrBefore(presentDate)
  ) {
    if (checkYearValid(year, presentDate)) {
      return true;
    }
    return false;
  }
  return false;
};

//added a condition for yyyy-mm-dd format
export const getDateInUIFormat = (
  dateValue?: IDateValue,
  withSpaces = true,
  apiDateFormat?: boolean,
  format?: string,
): string => {
  const date = dateValue ? moment(dateValue, format) : moment(); // Date
  const day = String(date.date()).padStart(2, '0');
  const month = String(date.month() + 1).padStart(2, '0');
  const year = String(date.year());
  if (apiDateFormat) {
    return `${year}-${month}-${day}`;
  }
  return withSpaces ? `${month} / ${day} / ${year}` : `${month}/${day}/${year}`;
};

export const getAutoPayDateInUIFormat = (
  dateValue?: IDateValue,
  withSpaces = false,
  apiDateFormat?: boolean,
  format?: string,
): string => {
  const date = dateValue ? moment(dateValue, format) : moment(); // Date
  const day = String(date.date()).padStart(2, '0');
  const month = String(date.month() + 1).padStart(2, '0');
  const year = String(date.year());
  if (apiDateFormat) {
    return `${year}-${month}-${day}`;
  }
  return withSpaces ? `${month} / ${day} / ${year}` : `*${month}/${day}/${year}`;
};

export const getDateInUIFormatForBinderPayNow = (
  dateValue?: IDateValue,
  withSpaces = true,
  apiDateFormat?: boolean,
  format?: string,
): string => {
  const effectivedate = dateValue ? moment(dateValue, format) : moment(); // Date
  const current = new Date();
  const currentdate = current ? moment(current, format) : moment();
  const lastDayOfCurrentMonth = new Date(
    current.getFullYear(),
    current.getMonth() + 1,
    0,
  );
  const effectiveMonth = moment(dateValue);
  const effectiveMonthEnd = moment(effectiveMonth).endOf('month');
  const LastDayOfCurrentMonth = lastDayOfCurrentMonth
    ? moment(lastDayOfCurrentMonth, format)
    : moment();
  let day = ' ';
  let month = ' ';
  let year = ' ';

  if (currentdate.valueOf() >= effectivedate.valueOf()) {
    day = String(LastDayOfCurrentMonth.date()).padStart(2, '0');
    month = String(LastDayOfCurrentMonth.month() + 1).padStart(2, '0');
    year = String(LastDayOfCurrentMonth.year());
  } else if (currentdate.valueOf() < effectivedate.valueOf()) {
    day = String(effectiveMonthEnd.date()).padStart(2, '0');
    month = String(effectiveMonthEnd.month() + 1).padStart(2, '0');
    year = String(effectiveMonthEnd.year());
  }

  if (apiDateFormat) {
    return `${year}-${month}-${day}`;
  }
  return withSpaces
    ? `${month} / ${day} / ${year}`
    : `${month + 1}/${day}/${year}`;
};

export const convertDateToUIFormat = (
  dateValue: Date,
  format: string,
): string => {
  const dayMonthFormatter = (day: number) =>
    day.toString().length === 1 ? '0' + day.toString() : day.toString();
  const day = dayMonthFormatter(dateValue.getDate());
  const month = dayMonthFormatter(dateValue.getMonth() + 1);
  const year = dateValue.getFullYear();
  switch (format) {
    case DATE_FORMAT_WITHOUT_SPACE:
      return `${month}/${day}/${year}`;
    case DATE_FORMAT_WITH_DASH:
      return `${year}-${month}-${day}`;
    case DATE_FORMAT_WITH_SPACE:
    default:
      return `${month} / ${day} / ${year}`;
  }
};

//To check if the date is equal to the current date
export const isPresentDayChecker = (
  dateValue: IDate,
  presentDate: string,
  dateValueFormat?: string,
  presentDateFormat?: string,
): boolean => {
  const date = moment(dateValue, dateValueFormat);
  const presentDay = presentDate
    ? moment(presentDate, presentDateFormat)
    : moment();
  return date.isSame(presentDay, 'day');
};

//used for testing give the next days date
export const getNextDay = (presentDate?: string) => {
  const today = presentDate ? moment(presentDate) : moment();
  today.add(1, 'days');
  return getDateInUIFormat(today.format('MM-DD-YYYY'), false, true);
};

export const getPreviousDay = (presentDate?: string) => {
  const today = presentDate ? moment(presentDate) : moment();
  today.subtract(1, 'days');
  return getDateInUIFormat(today.format('MM-DD-YYYY'), false, true);
};

export const getFormattedStringDate = (
  value: string | undefined,
  format?: string,
  commaSeperatedDate?: boolean,
): string => {
  const date = moment(value, format ? format : 'YYYY-MM-DD');
  if (commaSeperatedDate)
    return `${date.format('MMM')}, ${date.format('YYYY')}`;
  return `${date.format('MMM')} ${date.format('D')}, ${date.format('YYYY')}`;
};

export const formatServiceDateToLongMonth = (
  raw?: string | null,
): string => {
  const value = (raw || '').trim();
  if (!value) return '';

  let parsedDate = moment(value, 'YYYYMMDD', true);
  if (!parsedDate.isValid()) {
    parsedDate = moment(value, 'YYYY-MM-DD', true);
  }
  if (!parsedDate.isValid()) {
    parsedDate = moment(value);
  }
  if (!parsedDate.isValid()) {
    return value;
  }

  return parsedDate.format('MMMM D, YYYY');
};

//used for billing history for from date range view
export const getPreviousXMonthsDate = (serverDate: string, month: number) => {
  const today = moment(serverDate);
  today.subtract(month, 'months');
  return getDateInUIFormat(today.format('MM/DD/YYYY'), false);
};

//To check if the date is in between from date and to date
export const isSelectedDateInDateRange = (
  fromDate: string,
  toDate: string,
  checkDate: string,
): boolean => {
  return moment(checkDate).isBetween(fromDate, toDate, 'days', '[]');
};

//To get the day difference between given two dates
export const getDayDifference = (date1: Date, date2: Date): number => {
  const diffTime = Math.abs(date1.getTime() - date2.getTime());
  const diffDay = Math.round(diffTime / (1000 * 3600 * 24));
  return diffDay;
};

export const getMonthDifference = (date1: Date, date2: Date): number => {
  const startDate = moment(date1);
  const endDate = moment(date2);
  return endDate.diff(startDate, 'months');
};

// To check is the current day is the last day of the month or not
export const isDateLastDateOfTheMonth = (date: string): boolean => {
  const lastDate = moment(date).endOf('month').format('MM/DD/YYYY');
  return date == lastDate;
};

// To check if the date is after current date
export const isSameOrAfterCurrentDate = (
  date: string,
  format: string,
  serverDate: string,
): boolean => {
  return moment(date, format).isSameOrAfter(serverDate);
};

export const isSameOrBeforeCurrentDate = (
  date: string,
  format: string,
  serverDate: string,
): boolean => {
  return moment(date, format).isSameOrBefore(serverDate);
};

export const isBeforeCurrentDate = (
  date: string,
  format: string,
  serverDate: string,
): boolean => {
  return moment(date, format).isBefore(serverDate);
};

export const isAfterCurrentDate = (
  date: string,
  format: string,
  serverDate: string,
): boolean => {
  return moment(date, format).isAfter(serverDate);
};

export const getNextDateByDays = ({
  date,
  days,
  format,
}: {
  date: string;
  days: number;
  format: string;
}) => {
  return moment(date, format).add(days, 'days').toDate();
};

export const DATE_FORMAT_WITHOUT_SPACE = 'MM/DD/YYYY';
export const DATE_FORMAT_WITH_SPACE = 'MM / DD / YYYY';
export const DATE_FORMAT_WITH_DASH = 'YYYY-MM-DD';

export const sortArrayDateValueByKey = ({
  array,
  key,
  ascSortType = true,
}: {
  array: any; // added any as array object can be different for reusable
  key: string;
  ascSortType?: boolean;
}) => {
  return array
    .slice()
    .sort((firstArrayElement: any, secondArrayElement: any) => {
      const firstArrayKeyValue = new Date(firstArrayElement[`${key}`]);
      const secondArrayKeyValue = new Date(secondArrayElement[`${key}`]);
      if (firstArrayKeyValue > secondArrayKeyValue) {
        return ascSortType ? 1 : -1;
      }
      if (firstArrayKeyValue < secondArrayKeyValue) {
        return ascSortType ? -1 : 1;
      }
      return 0; // if date is equal no swap
    });
};

export const getLastDayOfMonth = (date: string, format?: string) => {
  return moment(date)
    .endOf('month')
    .format(format ? format : 'MM/DD/YYYY');
};

export const GOVT_MEDSUP_MAX_PAYMENT_DATE = '28';
export const getExclusiveDates = (
  duedate: string,
  format: string,
  serverDate: string,
) => {
  const monthsDiff = getMonthDifference(
    new Date(serverDate as string),
    new Date(duedate as string),
  );
  const exclusiveDatesArray = ['29', '30', '31'];
  const exclusiveDates: Date[] = [];

  // loop through number of months difference to disable the dates for each month
  for (let monthSeq = 0; monthSeq <= monthsDiff; monthSeq++) {
    const date1 = moment(serverDate)
      .add(monthSeq, 'months')
      .format('MM/DD/YYYY');
    const currentMonthfromDate = getCurrentMonth(date1);
    const currentMonth =
      currentMonthfromDate < 10
        ? `0${currentMonthfromDate}`
        : currentMonthfromDate;
    const currentYear = getCurrentYear(date1);
    const lastDayOfCurrentMonth = getLastDayOfMonth(date1);

    if (
      isAfterCurrentDate(
        duedate,
        format,
        `${currentMonth}/${GOVT_MEDSUP_MAX_PAYMENT_DATE}/${currentYear}`,
      )
    ) {
      exclusiveDatesArray.map((eachDate) => {
        //if excluded date is same date or before date of lastdayofmonth & duedate
        if (
          isSameOrBeforeCurrentDate(
            `${currentYear}-${currentMonth}-${eachDate}`,
            billPeriodFormat,
            lastDayOfCurrentMonth,
          ) &&
          isSameOrBeforeCurrentDate(
            `${currentYear}-${currentMonth}-${eachDate}`,
            billPeriodFormat,
            duedate,
          ) &&
          !isSameOrBeforeCurrentDate(
            `${currentYear}-${currentMonth}-${eachDate}`,
            billPeriodFormat,
            getDateInUIFormat(serverDate, false, true),
          )
        ) {
          // the excluded date should not be the server date then it is excluded date
          if (
            !isPresentDayChecker(
              serverDate,
              `${currentMonth}/${eachDate}/${currentYear}`,
              DATE_FORMAT_WITHOUT_SPACE,
              DATE_FORMAT_WITHOUT_SPACE,
            )
          ) {
            const dayDiff = getDayDifference(
              new Date(serverDate as string),
              new Date(`${currentYear}-${currentMonth}-${eachDate}` as string),
            );
            exclusiveDates.push(
              getNextDateByDays({
                date: serverDate,
                days: dayDiff,
                format: DATE_FORMAT_WITHOUT_SPACE,
              }),
            );
          }
        }
      });
    }
  }
  return exclusiveDates;
};

export const checkIsImmediatePayment = (
  duedate: string,
  format: string,
  serverDate: string,
): boolean => {
  const currentMonthfromDate = getCurrentMonth(serverDate);
  const currentYear = getCurrentYear(serverDate);
  const lastDayOfCurrentMonth = getLastDayOfMonth(serverDate);
  const currentMonth =
    currentMonthfromDate < 10
      ? `0${currentMonthfromDate}`
      : currentMonthfromDate;

  //If duedate is before current date OR if duedate is after 28th and before lastDayof current month then consider it as immediate payment
  return (
    isBeforeCurrentDate(duedate, billPeriodFormat, serverDate) ||
    (isAfterCurrentDate(
      getDateInUIFormat(serverDate, false, true),
      format,
      `${currentMonth}/${GOVT_MEDSUP_MAX_PAYMENT_DATE}/${currentYear}`,
    ) &&
      isSameOrBeforeCurrentDate(
        duedate,
        billPeriodFormat,
        lastDayOfCurrentMonth,
      ))
  );
};

/**
 * Calculate default date range for premium payment history
 * Start date: 18 months (approximately 1.5 years) ago from today
 * End date: Today
 * Returns dates in YYYYMMDD format (API expected format)
 */
export const getPremiumPaymentHistoryDateRange = (): {
  startDate: string;
  endDate: string;
} => {
  const today = moment();
  const endDate = today.format('YYYYMMDD');

  // Subtract 18 months from today
  const startDate = today.clone().subtract(18, 'months').format('YYYYMMDD');

  return { startDate, endDate };
};
